import { ProgramProductInformation } from '.';

export class AddOnProgramProductInformation{
    isSelected: boolean;
    programProductAddonId: number;
    primaryProgramProductId: number;
    addonProgramProductId: number;
    sortSequence: number;
    programProductInformation: ProgramProductInformation;
}